// extracted by mini-css-extract-plugin
module.exports = {"customArrow":"date-picker_customArrow__TTyo8","labels":"date-picker_labels__LL2P2"};